import { styled } from "../imports";
import Box from "./Box";
import { sizeProps, overflowProps, gridContainerProps, gridItemProps } from "../props";
import { spaceProp } from "../utils";
var Grid = /*#__PURE__*/styled(Box, {
  label: "Grid",
  target: "css-128w0st0"
})(sizeProps, ";", overflowProps, ";", gridContainerProps, ";", spaceProp(function (val) {
  return "grid-gap:" + val;
}), ";");
Grid.displayName = "Grid";
Grid.Item = /*#__PURE__*/styled(Box, {
  target: "css-128w0st1"
})(sizeProps, ";", gridItemProps, ";");
Grid.Item.displayName = "Grid.Item";
export default Grid;